/**
 *
 * @property {string} notStarted 회색
 * @property {string} active 주황색
 * @property {string} end 초록색
 * @property {string} cancel 빨간색
 * @property {string} waiting 입금대기 노란색
 * @property {string} pause 노란색
 *
 *
 * @type {{notStarted: string, active: string, end: string, cancel: string, waiting: string, pause: string}}
 */

const stateIcons = {
    notStarted: '/images/common_icon/ic_login_oneline_gray_small.svg',
    active: '/images/common_icon/ic_login_oneline_orange_small.svg',
    end: '/images/common_icon/ic_login_oneline_green_small.svg',
    cancel : '/images/common_icon/ic_login_oneline_red_small.svg',
    waiting: '/images/common_icon/ic_login_oneline_yellow_small.svg',
    pause: '/images/common_icon/ic_login_oneline_yellow_small.svg',
}

export default stateIcons;

